import React from 'react';
import {connect} from 'react-redux';
import {getParameterByName} from '../../../../helpers/location';
import PlayersListWidget from '../Widgets/PlayersList';

const PlayersDashboard = props => (
  <div id="players-dashboard">
    <header className="content-header">
      <h1>
        Players
        <small>FL1</small>
      </h1>
    </header>
    <section className="content">
      <PlayersListWidget
        championship={parseInt(
          getParameterByName('championship', props.location.search),
          10,
        )}
      />
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(PlayersDashboard);



// WEBPACK FOOTER //
// ./src/pages/MXI/Players/Dashboard/index.js